import React, { Component } from "react";
import { Link } from "react-router-dom";
import { makeGet } from "@culturehq/client";
import { Icon } from "@culturehq/components";

import { errorService } from "app/utils";

import LightboxModal from "components/common/gallery/LightboxModal";

const PhotoCreatedThumbnail = ({ photo, viewAll, index, eventId, onClick }) => {
  const backgroundImage = `url(${index === 0 ? photo.image.largeUrl : photo.image.mediumUrl})`;

  return (
    <div className="PhotoGroup__thumbnail">
      {viewAll && (
        <Link className="PhotoGroup__view-all" to={`/events/${eventId}/photos`}>
          <Icon icon="images" /> View all
        </Link>
      )}
      <div
        className="PhotoGroup__wrapper"
        onClick={() => onClick(index)}
        style={{ backgroundImage }}
      />
    </div>
  );
};

const getPhoto = event => photo => makeGet(`/photos/${photo.id}`).then(
  ({ cheersCount, cheersForUser }) => ({
    ...photo, event, cheersCount, cheersForUser
  })
);

class Multiple extends Component {
  constructor(props) {
    super(props);
    const { item } = props;

    this.state = {
      modalIsOpen: false,
      activePhoto: null,
      photos: [item].concat(item.childUserActivities).map(child => child.entity).reverse()
    };
  }

  async componentDidMount() {
    const { event } = this.props;
    const { photos } = this.state;

    try {
      const nextPhotos = await Promise.all(photos.map(getPhoto(event)));
      this.setState({ photos: nextPhotos });
    } catch (error) {
      errorService.error(error);
    }
  }

  handleThumbnailClick = goToIndex => {
    const { photos } = this.state;
    let target = goToIndex;

    if (goToIndex === -1) {
      target = photos.length - 1;
    }

    if (goToIndex > photos.length - 1) {
      target = 0;
    }

    this.setState({ activePhoto: photos[target], modalIsOpen: true });
  };

  handleClose = () => {
    this.setState({ modalIsOpen: false });
  };

  handlePhotoUpdate = update => {
    const { activePhoto } = this.state;
    this.setState(({ photos }) => ({
      photos: photos.map(photo => (
        photo.id === update.id ? { ...photo, ...update } : photo
      )),
      activePhoto: activePhoto.id === update.id
        ? { ...activePhoto, ...update } : activePhoto
    }));
  };

  handlePhotoDelete = deleted => {
    this.setState(state => ({
      photos: state.photos.filter(({ id }) => id !== deleted.id),
      modalIsOpen: false
    }));
  };

  handlePhotoCheerToggle = (photoId, cheerForUser, cheersCount) => {
    const { onPhotoCheerToggle } = this.props;

    this.setState(({ photos }) => ({
      photos: photos.map(photo => (
        photo.id !== photoId ? photo : ({ ...photo, cheerForUser, cheersCount })
      ))
    }));

    onPhotoCheerToggle(photoId, cheerForUser, cheersCount);
  };

  render() {
    const { event } = this.props;
    const { activePhoto, modalIsOpen, photos } = this.state;

    return (
      <>
        {activePhoto && (
          <LightboxModal
            modalIsOpen={modalIsOpen}
            activePhoto={activePhoto}
            photos={photos}
            onClose={this.handleClose}
            onPhotoChange={this.handleThumbnailClick}
            onDelete={this.handlePhotoDelete}
            onPhotoCheerToggle={this.handlePhotoCheerToggle}
            onPhotoUpdate={this.handlePhotoUpdate}
          />
        )}
        <div className="FeedItem__preview__photo_created_multiple clearfix" key="preview">
          <div className={`PhotoGroup PhotoGroup-${photos.length >= 6 ? "6" : photos.length}`}>
            {photos.slice(0, 6).map((photo, index) => (
              <PhotoCreatedThumbnail
                key={photo.id}
                photo={photo}
                index={index}
                onClick={this.handleThumbnailClick}
                eventId={event.id}
                viewAll={index === 5}
              />
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default Multiple;
